import React, { FC } from 'react';
import { FindingTypeDetails, FindingTypeProperty, FindingTypeRuleDetails } from '../../../AnnotationStandardForm/AnnotationStandardForm.slice';
import { CreateAnnotationProperty } from '../AnnotationForm.types';
import styles from '../AnnotationForm.module.scss';
import Busy from '../../../../Shared/Busy';
import PropertyInput from './PropertyInput';

type Props = {
  selectedFindingType: FindingTypeDetails | null;
  properties: CreateAnnotationProperty[][];
  selectedProperties: FindingTypeProperty[];
  selectedRules: FindingTypeRuleDetails[];
  setProperties: (properties: CreateAnnotationProperty[][]) => void;
  isWarrantyCaseClosed: boolean;
};

const Properties: FC<Props> = ({ selectedFindingType, properties, selectedProperties, selectedRules, setProperties, isWarrantyCaseClosed }) => {
  const generatePropertyInput = (group: CreateAnnotationProperty[], property: CreateAnnotationProperty, index: number) => {
    var propertyTemplate = selectedProperties.find(x => x.id === property.findingTypePropertyId);

    if (propertyTemplate) {
      return (
        <PropertyInput
          key={property.findingTypePropertyId}
          propertyTemplate={propertyTemplate}
          group={group}
          property={property}
          index={index}
          selectedRules={selectedRules}
          properties={properties}
          updateProperties={updatedProperties => setProperties(updatedProperties)}
          isWarrantyCaseClosed={isWarrantyCaseClosed}
        />
      );
    }
  };

  return (
    <>
      {selectedFindingType && (
        <>
          {!selectedProperties.length && (
            <div className={styles.iconSpinner}>
              <Busy />
            </div>
          )}
          {properties.map((group, index) => (
            <div key={index} className={index === 1 ? styles.disabledRows : styles.enabledRows}>
              {group.map((property, index) => generatePropertyInput(group, property, index))}
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default Properties;
